import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faCheck,
  faClose,
  faEye,
  faHome,
  faPlug,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import {
  confirmDeleteToast,
  sendError,
  sendSuccess,
  status,
} from "../helpers/Helper";
import { API_URL_ENDPOINT } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import { useApi, useHasPermission } from "../helpers/useApi";
import OffCanvas from "../components/OffCanvas";
import { Accordion } from "react-bootstrap";
import { Textbox } from "../components/Textbox";
import { Model } from "../components/Model";
import { SelectBox } from "../components/SelectBox";
import Permissions from "../Routes/permissions";

export const KycDocs = () => {
  const callApi = useApi();
    const hasPermission = useHasPermission();
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
  });

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (isTyping) {
        setIsTyping(false);
        getData(1);
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  const handlePageChange = (newPage) => {
    getData(newPage);
  };

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`);
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${cp ?? data.pageNo}`,
        `pageSize=${data.pageSize}`,
        `orderBy=lastUpdate`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.KYC + "/docs" + `?${queryParams}`
      );
      if (response.status) {
        setData(response.data);
      }
    } catch {
      setData({
        items: [],
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
        totalRecords: 0,
      });
    } finally {
      setDataLoading(false);
    }
  };

  const submitForm = async (data) => {
    if (data == null) return;
    // console.log("data", data)
    // return;
    try {
      const payload = {
        documentTitle: data.title || "",
        documentDescription: data.description || "",
        // "allowedExtensions": [
        //   "DOC"
        // ],
        minSizeInKB: parseInt(data.minSize) || 0,
        maxSizeInKB: parseInt(data.maxSize) || 0,
      };

      const response = await callApi(API_URL_ENDPOINT.KYC + "/doc", {
        method: "POST",
        data: payload,
      });
      if (response.status) {
        setShowModel(false);
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  return (
    <>
      <Model show={showModel} size={"lg"}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Add Document</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() => setShowModel(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(submitForm)}>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Document Name"
                    name={"title"}
                    Placeholder="Documemt Name"
                    validationRules={{ required: "Document Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Description"
                    name={"description"}
                    Placeholder="Description"
                    validationRules=""
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Mininum Size"
                    name="minSize"
                    Placeholder="Minimim Size (in KB)"
                    validationRules=""
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Maximum Size"
                    name="maxSize"
                    Placeholder="Maximum Size (in KB)"
                    validationRules=""
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2"
                variant="outline-danger"
                onClick={() => setShowModel(false)}
              >
                Close
              </Button>
              <Button type="submit" disabled={isSubmitting} variant="success">
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>

      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>KYC Documents</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">KYC Documents</h4>
          </div>
        </div>
        <div className="d-flex align-items-center">
          {hasPermission(Permissions.KYC.CreateDocument) && (
          <Button
            onClick={() => setShowModel(true)}
            className="me-2 d-block"
            variant="primary"
            style={{ whiteSpace: "nowrap" }}
          >
            <FontAwesomeIcon icon={faPlus} /> Add New Document
          </Button>
          )}

          <Form.Control
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setIsTyping(true);
            }}
            type="text"
            className="shadow-none"
            placeholder={"Search..."}
          />
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
          {dataLoading ? (
            <div className="text-center my-3">
              <span
                className="spinner-border text-primary"
                role="status"
              ></span>
            </div>
          ) : (
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Document Name</th>
                  <th className="border-0 text-center">Description</th>
                  <th className="border-0 text-center">Allowed Extention</th>
                  <th className="border-0 text-center">Allowed Size</th>
                  <th className="border-0 text-center">Status</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.length > 0 ? (
                  data?.items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(data.pageNo - 1) * data.pageSize + index + 1}
                      </td>

                      <td className="fw-bold align-middle text-center">
                        {item.documentTitle || "-"}
                      </td>

                      <td className="fw-bold align-middle text-center">
                        {item.documentDescription || "-"}
                      </td>

                      <td className="fw-bold align-middle text-center">
                        {item.allowedExtensions &&
                        item.allowedExtensions.length > 0
                          ? item.allowedExtensions.join(", ")
                          : "-"}
                      </td>

                      <td className="fw-bold align-middle text-center">
                        {item.minSizeInKB && item.maxSizeInKB
                          ? `${item.minSizeInKB}KB - ${item.maxSizeInKB}KB`
                          : "-"}
                      </td>

                      <td className="fw-bold align-middle text-center">
                        {item.isActive ? status("Active") : status("Disabled")}
                      </td>

                      <td className="text-end align-middle">
                        {/* Add any buttons or actions here */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
          <div className="d-flex justify-content-end">
            <CustomPagination
              totalPages={data.totalPage}
              loading={dataLoading}
              onPageChange={handlePageChange}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
